export enum WeightUnit {
  Lbs,
  Kg,
}
